import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "./analyze.scss";

import STLViewer from "../../STLViewer";
import { getAnlayzerStatus } from "../../services/part/partService";

const Analyze = (props) => {
  const [showModal, setShowModal] = useState(true);
  const internalTime = 20000;

  useEffect(() => {
    setTimeout(() => {
      checkAnalyzeStatus();
    }, 10000);
  }, []);


  const handleCloseModal = () => {
    setShowModal(false);
  };

  const checkAnalyzeStatus = () => {
    getStatus();
  };

  const getStatus = async () => {
    await getAnlayzerStatus(props.partId, props.modelName).then((response) => {
      if (Object.values(response)[0] === "True") {
        setShowModal(false);
        props.handleNext();
      }
      else {
        setTimeout(() => {
          getStatus();
        }, internalTime);
      }
    }).catch((error) => {
      if (error.response.status === 404) {
        setTimeout(() => {
          getStatus();
        }, internalTime);
      }
    });
  };

  return (
    <div>
      <Modal show={showModal} onHide={handleCloseModal} centered backdrop={false}>
        <Modal.Header>
          <Modal.Title>Analyze results</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          className="modal-body"
        >
          <div className="analyze-panel-content">
            <p className="content">
              Please wait... Results from the detailed analysis are still not
              available. <span className="loader"></span>
            </p>
          </div>
        </Modal.Body>
      </Modal>
      <section className="plates page review-page">
        <section className="plate view">
          <STLViewer
            showPartDetails={false}
            partName={props.partName}
            modelName={props.modelName}
            partId={props.partId}
          />
        </section>
      </section>
    </div>
  );
};

export default Analyze;
